<template>
  <RoundButton @click.native="$emit('pause')">
    <svg
      class="icon"
      viewBox="0 0 18 25"
    >
      <path
        d="M6 .004H2c-.733 0-1.333.6-1.333 1.333v21.334c0 .733.6 1.333 1.333 1.333h4c.733 0 1.333-.6 1.333-1.333V1.337C7.333.604 6.733.004 6 .004zm10.667 0h-4c-.734 0-1.334.6-1.334 1.333v21.334c0 .733.6 1.333 1.334 1.333h4c.733 0 1.333-.6 1.333-1.333V1.337c0-.733-.6-1.333-1.333-1.333z"
        fill="#FFF"
      />
    </svg>
  </RoundButton>
</template>

<script>
import RoundButton from '@/components/RoundButton'

export default {
  name: 'PauseButton',
  components: {
    RoundButton
  }
}
</script>

<style lang="scss" scoped>
.icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 20px;
  height: 28px;
}
</style>
